import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addonInstall } from '@api/sdk.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { queryKeys } from '../query-keys';

interface UpgradeAddonPayload {
  version: string;
  values: Record<string, unknown>;
}

// POST /addons/{id} performs helm upgrade --install, so the upgrade is a reuse
// of the install endpoint. Unlike useInstallAddon this does not touch team
// access (managed on the User Access tab) and invalidates the detail query too,
// so useAddon picks up the new lifecycle state as it polls.
export function useUpgradeAddon(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ version, values }: UpgradeAddonPayload) =>
      addonInstall({
        path: { id },
        body: { version: version || undefined, values },
      }),
    ...withInvalidate(queryClient, [queryKeys.list(), queryKeys.detail(id)]),
    ...withError('Unable to upgrade the add-on'),
  });
}
